import React from "react";
import logo from "../assets/images/logo_polotierra.png";
import "./index.css"

function Header() {
  return (
    <header>
      <img src={logo} alt="Afinia Logo" height="40" className="logo" />
    </header>
  );
}

export default Header;
